module.exports = __webpack_public_path__ + "static/media/twilio.6a4543f5.svg";